<template>
  <div class="english-container">
    <h2>Produktübersicht</h2>
    <p style="text-align: left;">Wir freuen uns mit Ihnen über den Wireless Tag für Android-Tracker, der nahtlos in die Google Find Hub App integriert ist und Ihnen hilft, Ihre Gegenstände mit Hilfe von Milliarden Android-Geräten weltweit zu finden.</p>

    <p style="text-align: left;">Der Wireless Tag ist ein intelligenter Tracker, der den Google Find Hub-Dienst nutzt und zusammen mit der „Find Hub“-App auf Android-Geräten verwendet wird, um Ihre persönlichen Gegenstände schnell und sicher auf Google Maps zu lokalisieren. Alle Standortinformationen bleiben privat – selbst Google kann darauf nicht zugreifen.</p>

    <h3>1. Anmeldung bei der Find Hub App</h3>
    <ol>
      <li>Gehen Sie zum Google Play Store und suchen Sie nach 'Find Hub'.</li>
      <li>Installieren Sie die App oder klicken Sie auf 'Aktualisieren'.</li>
      <li>Klicken Sie auf 'Öffnen' oder öffnen Sie das Find Hub App-Symbol auf Ihrer Startseite.</li>
      <li>Melden Sie sich mit Ihrem Google-Konto bei der Find Hub Seite an. Sie können ggf. das Kästchen 'Nicht erneut fragen' auswählen. Wenn Sie mehrere Konten haben, wird das Gerät dem primären Konto zugeordnet, das auf Ihrem Smartphone eingerichtet ist.</li>
      <li>Sie werden möglicherweise aufgefordert, einige Berechtigungen zu akzeptieren. Lesen Sie die Nutzungsbedingungen und fahren Sie fort.</li>
    </ol>

    <h3>2. Gerät einschalten</h3>
    <p style="text-align: left;">
      <strong>Einschalten:</strong> Halten Sie den runden Punkt auf dem Ein-/Ausschaltknopf Ihres Geräts 3 Sekunden lang gedrückt. Wenn Sie einen Doppelton hören, ist das Gerät eingeschaltet. (Siehe Abbildung)
    </p>

    <img src="../assets/gid_1.png" alt="Wireless Tag Logo" class="image_1" />

    <h3>3. Verbinden mit der Find Hub App</h3>
    <p style="text-align: left;">
      3.1 Stellen Sie sicher, dass Bluetooth auf Ihrem Smartphone aktiviert ist und eine Internetverbindung besteht.
    </p>
    <p style="text-align: left;">
      3.2 Bringen Sie Ihren Tag nah an Ihr Smartphone heran und warten Sie, bis das Pop-up "Wireless Tag" angezeigt wird. Tippen Sie im unteren Bereich des Pop-ups auf „Verbinden“. Lesen und bestätigen Sie anschließend die Hinweise, um die Verbindung abzuschließen.
    </p>

    <h3>4. Produktbeschreibung</h3>
    <h4>4.1 Ortung in der Nähe</h4>
    <p style="text-align: left;">
      4.1.1 Manchmal sind Sie Ihrem verlorenen Gegenstand näher, als Sie denken. Wenn Sie wissen, dass er sich irgendwo im Haus befindet, zeigt Ihnen Find Hub die Signalstärke an, sodass Sie den Standort eingrenzen können.
    </p>
    <p style="text-align: left;">
      4.1.2 Befindet sich Ihr Gerät innerhalb der Reichweite, wählen Sie es in der „Find Hub“-App aus und tippen Sie auf „Ton abspielen“, um das Gerät zu lokalisieren. Sobald Sie es gefunden haben, tippen Sie auf „Ton stoppen“, um das Gerät zu stummschalten.
    </p>
    <p style="text-align: left;">
      4.1.3 Der Google Assistant auf Ihrem Google Home oder Ihrer Pixel-Uhr hilft Ihnen dabei. Nutzen Sie Sprachbefehle wie „Hey Google, finde meine Geldbörse“ oder „Hey Google, finde meine Schlüssel“, um Ihre Gegenstände schnell zu finden.
    </p>

    <h4>4.2 Gemeinschaftsunterstützung</h4>
    <p style="text-align: left;">
      Wenn Sie sich weit von einem Gegenstand entfernt befinden, hilft Ihnen das Find Hub Netzwerk weiter. Android-Geräte weltweit – wie Tablets, Handys und Laptops – arbeiten gemeinsam daran, Ihnen beim Auffinden verlorener Gegenstände zu helfen.
    </p>

    <h4>4.3 Verloren-Modus aktivieren</h4>
    <p style="text-align: left;">
      Wenn Ihr Gegenstand verloren geht, wählen Sie das Gerät in der „Find Hub“-App aus und tippen Sie auf „Als verloren markieren“. Sie erhalten eine Benachrichtigung, sobald ein Standort verfügbar ist. Hinterlassen Sie Ihre Kontaktdaten, damit der Finder sich mit Ihnen in Verbindung setzen kann.
    </p>

    <h4>4.4 Freigabe des Standorts</h4>
    <p style="text-align: left;">
      Wählen Sie das Gerät in der „Find Hub“-App aus und tippen Sie dann auf „Gerät teilen“. Nachdem der Besitzer des Zubehörs die Freigabe bestätigt hat, erscheint es auf der Liste in der Find Hub App. Beide Konten sehen die Standortaktualisierungen und können das Gerät lokal zum Piepen bringen.
    </p>

    <h4>4.5 Warnung vor unbekanntem Tracker</h4>
    <p style="text-align: left;">
      Ihre Sicherheit steht an erster Stelle. Find Hub wurde entwickelt, um unerlaubtes Tracking zu verhindern. Falls Ihr Android-Telefon bemerkt, dass ein unbekanntes Gerät Sie begleitet, erhalten Sie eine Benachrichtigung. Sehen Sie das unbekannte Gerät auf der Karte, lassen Sie es per Ton finden oder holen Sie weitere Unterstützung ein.
    </p>

    <h4>4.6 Datenschutz</h4>
    <p style="text-align: left;">
      Ihre Standortdaten sind Ende-zu-Ende verschlüsselt, was bedeutet, dass Google diese niemals einsehen oder nutzen kann. Nur Sie können sehen, wo sich Ihre Gegenstände befunden haben und aktuell befinden. Mit der Find Hub App nutzt Google keine noch geteilte Daten. Die Informationen, die Sie über sich und Ihre Geräte preiszugeben bereit sind, bleiben vertraulich.
    </p>

    <h3>5. Batteriewechsel</h3>
    <p style="text-align: left;">
      5.1 Stecken Sie das Öffnungswerkzeug in die Gehäusespaltöffnung.
    </p>
    <p style="text-align: left;">
      5.2 Drehen Sie das Gehäuseöffnungswerkzeug um 90 Grad, um das Gehäuse zu öffnen.
    </p>
    <p style="text-align: left;">
      5.3 Nutzen Sie Ihre Fingernägel am kleinen Spalt an der Seite des Item Locators, um das Gehäuse vorsichtig zu öffnen.
    </p>
    <p style="text-align: left;">
      5.4 Ersetzen Sie die Batterie durch eine neue CR2032-Batterie mit 3 V Spannung (Pluspol nach oben).
    </p>

    <img src="../assets/open_tag.png" alt="Wireless Tag Logo" class="image_1" />

    <h3>6. Funktionen der Taste</h3>
    <ol>
      <li style="text-align: left;">
        Einschalten (Find My-Funktion aktiviert)
        <p>Drücken Sie die Funktionstaste 3 Sekunden lang, um das Gerät einzuschalten. Sie hören einen Doppelton, der das Einschalten signalisiert. Ist das Gerät nicht mit Ihrem Google-Konto verbunden, schaltet es sich nach 10 Minuten automatisch ab. Sie müssen die Find My-Funktion erneut auslösen, um die Paarung fortzusetzen.</p>
      </li>
      <li style="text-align: left;">Ausschalten (Find My-Funktion deaktiviert)</li>
      <p style="text-align: left;">Halten Sie die Funktionstaste drei Sekunden lang gedrückt und lassen Sie sie dann los… Sie hören zwei Töne, die das Ausschalten signalisieren.</p>
      <strong style="text-align: left;">
        <p>Hinweis:</p>
        <p>1. Wenn Sie die Taste weniger als 3 Sekunden oder länger als 5 Sekunden drücken, wird das Gerät nicht ausgeschaltet.</p>
        <p>2. Die Einstellung eines Abschaltung-Timers dient dazu, versehentliches Ausschalten zu vermeiden und sicherzustellen, dass das Gerät effektiv weiterhin orten kann.</p>
      </strong>

      <li style="text-align: left;">Auf Werkseinstellungen zurücksetzen</li>
      <p style="text-align: left;">Drücken Sie die Funktionstaste zweimal, Sie hören einen Piepton. Drücken Sie die Taste viermal schnell hintereinander und halten Sie sie beim fünften Mal so lange gedrückt, bis Sie einen Doppelpiepton hören – nun ist das Gerät zurückgesetzt.</p>
    </ol>

    <h3>FAQ</h3>
    <h4>Kann das Gerät nicht mit der Google Find My Device App verbunden werden? Folgende Maßnahmen werden empfohlen:</h4>
    <ol>
      <li style="text-align: left;">Starten Sie Bluetooth und Mobilfunknetz Ihres Telefons neu. Schalten Sie das Gerät aus und wieder ein und warten Sie, bis „Wireless Tag“ als Pop-up erscheint.</li>
      <li style="text-align: left;">Setzen Sie das Gerät zurück. Schalten Sie das Gerät aus und wieder ein und warten Sie, bis „Wireless Tag“ als Pop-up erscheint.</li>
      <li style="text-align: left;">Starten Sie Ihr Telefon neu. Schalten Sie das Gerät aus und wieder ein und warten Sie, bis „Wireless Tag“ als Pop-up erscheint.</li>
      <li style="text-align: left;">Aktualisieren Sie die Software Ihres Smartphones.
        <p>Schritt 1: Gehen Sie in die Einstellungen und suchen Sie „System“.</p>
        <p>Schritt 2: Suchen Sie nach „Software-Updates“ und öffnen Sie „Systemaktualisierung“, um nach Updates zu suchen.</p>
        <p>Schritt 3: Aktualisieren Sie das Betriebssystem Ihres Telefons auf die neueste Version.</p>
      </li>
      <li style="text-align: left;">Suchen Sie nach Google-Diensten, um das Gerät zu verbinden.
        <p>Schritt 1: Gehen Sie in die Einstellungen und öffnen Sie „Google Dienste & Einstellungen“.</p>
        <p>Schritt 2: Gehen Sie zu „Alle Dienste“.</p>
        <p>Schritt 3: Gehen Sie zu „Verbundene Geräte & Teilen“.</p>
        <p>Schritt 4: Gehen Sie zu „Geräte“ und wählen Sie „In der Nähe verfügbare Geräte“. Wenn Sie „Wireless Tag“ sehen, tippen Sie darauf und warten Sie, bis das Pop-up „Wireless Tag“ erscheint.</p>
        <p>Schritt 5: Wenn „Wireless Tag“ nicht angezeigt wird, schalten Sie das Gerät aus und wieder ein, bis „Wireless Tag“ erscheint. Oder setzen Sie das Gerät zurück, schalten Sie es ein und warten Sie, bis „Wireless Tag“ angezeigt wird. Tippen Sie danach darauf, warten Sie auf das Pop-up und verbinden Sie es.</p>
      </li>
    </ol>

    <p style="text-align: left; color:#333">Sobald das Gerät mit einem Google-Konto verknüpft ist, ist es für andere Benutzer nicht mehr zugänglich.</p>
    <p style="text-align: left; color:#333">Wenn sich Ihr Gegenstand in der Nähe befindet, können Sie ihn in der App löschen. Es erklingt ein Doppelpiepton, der den erfolgreichen Löschvorgang signalisiert. Danach kann der Gegenstand von anderen Personen genutzt werden.</p>
    <p style="text-align: left; color:#333">Befindet sich Ihr Gegenstand außerhalb der Reichweite Ihres Smartphones und wurde der Locator aus der Find My App gelöscht, kann das Gerät von anderen Personen nicht genutzt werden. Sie müssen den Locator zurücksetzen, damit andere ihn verwenden können.</p>

    <h3>WARNUNG</h3>
    <ol>
      <li>Entfernen und recyceln oder entsorgen Sie gebrauchte Batterien gemäß den örtlichen Vorschriften. Halten Sie sie von Kindern fern. Werfen Sie Batterien NICHT in den Haushaltsabfall oder verbrennen Sie sie.</li>
      <li>Auch gebrauchte Batterien können schwere Verletzungen oder sogar den Tod verursachen.</li>
      <li>Kontaktieren Sie ein lokales Giftinformationszentrum für Behandlungsinformationen.</li>
      <li>Nicht aufladbare Batterien dürfen nicht aufgeladen werden.</li>
      <li>Batterien nicht gewaltsam entladen, aufladen, auseinanderbauen, über 50°C/122°F erhitzen oder verbrennen. Dies kann zu Verletzungen durch Entlüftung, Leckagen oder Explosionen mit chemischen Verbrennungen führen.</li>
      <li>Das kompatible Batteriemodell ist CR2032.</li>
      <li>Die Nennspannung beträgt DC 3V.</li>
      <li>Stellen Sie sicher, dass die Batterien korrekt installiert sind entsprechend der Polarität (+ und -).</li>
      <li>Mischen Sie keine alten und neuen Batterien, verschiedene Marken oder Typen wie Alkaline-, Zink-Kohle- oder Akku-Batterien.</li>
      <li>Entfernen und entsorgen Sie Batterien von Geräten, die längere Zeit nicht verwendet wurden, sofort gemäß den örtlichen Bestimmungen.</li>
      <li>Stellen Sie sicher, dass das Batteriefach ordnungsgemäß geschlossen ist. Sollte dies nicht der Fall sein, beenden Sie die Nutzung des Produkts, entfernen Sie die Batterien und halten Sie diese von Kindern fern.</li>
    </ol>

    <h5>
      <p>Batterietyp: CR2032. Batteriespannung: 3V.</p>
      <p>Lassen Sie die Batterie in der Originalverpackung, bis Sie sie benötigen.</p>
      <p>Entsorgen Sie gebrauchte Batterien sofort und halten Sie sie von Kindern fern. Werfen Sie Batterien NIEMALS in den Haushaltsabfall.</p>
    </h5>

    <img src="../assets/image_battery.png" class="image_1" />
  </div>
</template>

<script>
export default {
  name: 'DeutschLuage',
};
</script>

<style scoped>
.english-container {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 10px;
  margin: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

h1, h2,h3,h4,h5 {
  color: #333;
 text-align: left; /* 明确标题左对齐（如果父级未继承） */

}
ul, ol {
  margin-left: 20px;
  padding-left: 15px;
 list-style-type: decimal; /* 强制显示数字编号 */

}
li {
  margin-bottom: 8px;
  text-align: left;
  color: #000000;
}

.image_1 {
  width: 90%; /* 或根据需要调整 */
  height: auto;
  margin-bottom: 10px;
  border-radius: 8px;
}

</style>